import jssVariables from "../../../jss_setup";

export const lpMainSearchFormStyles = {
  mainSearchForm: {
    smallscreen: {
      bottom: "4.5rem",
    },
  },
  inputGroupField: {
    label: {
      fontSize: "medium",
      fontWeight: 400,
    },
  },
};

export const mainSFormNavBtnStyles = {
  label: { color: "black" },
};

export const mainPromoStyles = {};
export const landingPage = {};

export const landingPageSplashStyles = {
  imgOverlay: {
    background:
      "linear-gradient(180deg, rgba(57, 110, 150, 0) 7.6%, rgba(52, 83, 130, 0.862275) 42.08%, #041330 69.13%)",
  },
  slide: {
    smallscreen: {
      height: "100vh",
    },
  },
  headerContainer: {
    gridGap: `calc(${jssVariables.normal_gap} * 1)`,
    smallscreen: {
      display: "grid",

      top: "35%",
    },
  },
  header: {
    fontWeight: "bold",
    fontSize: "xx-large!important",
    smallscreen: {
      fontSize: "xxx-large!important",
    },
  },
  subheader: {
    fontWeight: "400",
    fontSize: "large",
    textShadow: "rgba(0, 0, 0, 0.25) 0px 2px 4px",
    display: "none",
    smallscreen: {
      display: "block",
    },
  },
  callToActions: {
    display: "none",
  },
};

export const paxModalCustomStyles = {
  paxGroup: {
    borderColor: jssVariables.colors.base_color,
    color: jssVariables.colors.base_color,
  },
  paxBtn: {},
  paxPlusBtn: {
    background: jssVariables.colors.base_color,
  },
  ageItem: {
    color: jssVariables.colors.base_color,
    "& select": {
      padding: jssVariables.normal_gap,
      border: `2px solid ${jssVariables.colors.base_color}`,
    },
  },
  cancelBtn: {
    borderColor: jssVariables.colors.base_color,
    color: jssVariables.colors.base_color,
  },
  applyBtn: {
    background: jssVariables.colors.base_color,
    borderColor: jssVariables.colors.base_color,
  },
};
